module.exports = __webpack_public_path__ + "img/qrcode.833a169e.png";